import { render } from "./ButtonSocial.vue?vue&type=template&id=cb591a44&scoped=true"
import script from "./ButtonSocial.vue?vue&type=script&lang=js"
export * from "./ButtonSocial.vue?vue&type=script&lang=js"

import "./ButtonSocial.vue?vue&type=style&index=0&id=cb591a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb591a44"]])

export default __exports__